/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Discover_Body_2Inputs */

const en_how_we_work_discover_body_2 = /** @type {(inputs: How_We_Work_Discover_Body_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Together, we choose a first phase worth building, one task or a whole system, and agree what a good result would look like.`)
};

const lv_how_we_work_discover_body_2 = /** @type {(inputs: How_We_Work_Discover_Body_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopā izvēlamies pirmo posmu, ko vērts izveidot, — vienu uzdevumu vai visu sistēmu — un vienojamies, kā izskatās labs rezultāts.`)
};

/**
* | output |
* | --- |
* | "Together, we choose a first phase worth building, one task or a whole system, and agree what a good result would look like." |
*
* @param {How_We_Work_Discover_Body_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_discover_body_2 = /** @type {((inputs?: How_We_Work_Discover_Body_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Discover_Body_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_discover_body_2(inputs)
	return en_how_we_work_discover_body_2(inputs)
});